import { render, staticRenderFns } from "./TagSelectionDialog.vue?vue&type=template&id=3ec0e18e&scoped=true"
import script from "./TagSelectionDialog.vue?vue&type=script&lang=js"
export * from "./TagSelectionDialog.vue?vue&type=script&lang=js"
import style0 from "./TagSelectionDialog.vue?vue&type=style&index=0&id=3ec0e18e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec0e18e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ec0e18e')) {
      api.createRecord('3ec0e18e', component.options)
    } else {
      api.reload('3ec0e18e', component.options)
    }
    module.hot.accept("./TagSelectionDialog.vue?vue&type=template&id=3ec0e18e&scoped=true", function () {
      api.rerender('3ec0e18e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationsManage/weChatUserManage/components/TagSelectionDialog.vue"
export default component.exports